import { Button, Modal, Form, Row, Col, message, Select } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { handleMigrateUser } from "../../../api/user";
import { handleFetchCompanies } from "../../../api/company";

const { Option } = Select;

export default function MigrateUser({
  isVisible,
  setVisible,
  company,
  user,
  refetch,
}: any) {
  const [form] = Form.useForm();

  const { data: companies } = useQuery({
    queryKey: ["companies"],
    queryFn: handleFetchCompanies,
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: handleMigrateUser,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      refetch();
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { company } = await form.getFieldsValue();
    const data = {
      company,
    };
    await mutate({ data, _id: user?._id });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const companyOptions = companies?.payload
    ?.filter((i: any) => i?._id !== user?.company)
    .map((company: any, index: number) => (
      <Option value={company?._id} key={index}>
        {company?.name}
      </Option>
    ));

  return (
    <Modal
      open={isVisible}
      title="Migrate Member"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="migrateUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Migrate
        </Button>,
      ]}
    >
      <Form
        id="migrateUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="">
          <div className="mb-1">MIGRATE FROM</div>
          <div className="font-bold">{company?.name}</div>
          <div className="my-2">TO</div>
        </div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="company"
              label="Company"
              rules={[
                {
                  required: true,
                  message: "Please select company",
                },
              ]}
            >
              <Select placeholder="Company">{companyOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
